import { useState } from "react";
import classNames from "classnames";
import { Button, TextArea, Typography } from "components/atoms";
import { Star, SuccessFeedback } from "components/atoms/Icon";
import { useAddFeedbackMutation } from "services/homeApi";
import { FetchError } from "components/molecules";
import "./index.scss";

interface IProps {
  data: any;
  theme?: "light" | "dark";
  handleRefresh?: () => void;
}

export const TabFeedback = ({ data, theme, handleRefresh }: IProps) => {
  const [selectedRate, setSelectedRate] = useState(0);
  const [textValue, setTextValue] = useState("");

  const [submitFeedback, { isLoading, isError }] = useAddFeedbackMutation();

  const handleClick = (value: number) => {
    setSelectedRate(value);
  };

  const handleSubmit = async (
    segmemntId: number,
    rating: number,
    text: string
  ) => {
    try {
      await submitFeedback({
        ProductOfferingSegmentId: segmemntId,
        Rating: rating,
        FeedbackText: text,
      })
        .unwrap()
        .then(() => {
          if (handleRefresh) {
            handleRefresh();
          }
        });
    } catch (error) {
      console.log("error : ", error);
    }
  };

  return (
    <div
      className={classNames("tab-feedback-wrapper")}
      key={data.ProductOfferingSegmentId}
    >
      {data && data.Feedback === null ? (
        <>
          <Typography
            variant="h7Med"
            label="How would you rate the class lecture?*"
          />
          <div className={classNames("tab-feedback-rating-numbers-wrapper")}>
            <Star
              fillColor={selectedRate >= 1 ? "#329EE2" : "none"}
              handleOnClick={() => handleClick(1)}
            />
            <Star
              fillColor={selectedRate >= 2 ? "#329EE2" : "none"}
              handleOnClick={() => handleClick(2)}
            />
            <Star
              fillColor={selectedRate >= 3 ? "#329EE2" : "none"}
              handleOnClick={() => handleClick(3)}
            />
            <Star
              fillColor={selectedRate >= 4 ? "#329EE2" : "none"}
              handleOnClick={() => handleClick(4)}
            />
            <Star
              fillColor={selectedRate === 5 ? "#329EE2" : "none"}
              handleOnClick={() => handleClick(5)}
            />
          </div>
          <div className={classNames("tab-feedback-desc-wrapper")}>
            <Typography
              variant="h7Med"
              label="Tell us what you think: (optional)"
            />
            <TextArea rows={6} setValue={setTextValue} />
          </div>
          {isError ? (
            <FetchError content="Oops! failed to load resources." />
          ) : null}
          <div className={classNames("tab-feedback-btn-wrapper")}>
            <Button
              isDisabled={selectedRate === 0 ? true : false}
              icon={false}
              label="Submit"
              isLoading={isLoading}
              onClick={() =>
                handleSubmit(
                  data.ProductOfferingSegmentId,
                  selectedRate,
                  textValue
                )
              }
            />
          </div>
        </>
      ) : (
        <div className="feedback-alert-wrapper">
          <SuccessFeedback
            fillColor={theme === "light" ? "#393939" : "white"}
          />
          <Typography variant="h8Med" label="Thanks for your feedback!" />
        </div>
      )}
    </div>
  );
};
